import cn from 'classnames';
import React from 'react';

import { IconSizeMap } from './Icon.constants';
import { IIconProps } from './Icon.types';

import './icon.scss';

const Icon: React.FC<IIconProps> = ({
  className = '',
  name,
  theme,
  size = 24,
  asVector = false,
}) => {
  const iconClassName = cn('icon', className, theme, [IconSizeMap[size]], {
    [`icon-${name}_${IconSizeMap[size]}`]: asVector,
    [name]: !asVector,
    vector: asVector,
  });

  return <i className={iconClassName} />;
};

export default Icon;
